import React from 'react';

import FieldWrapper from '../Field-wrapper';
import styles from '../Fields.module.less';

import { normalizeCSSID } from '$Validation/Normalizer';

/**
 *
 * @deprecated all new forms should use HVUI/FormikForm and HVUI/FormControl
 */
class RadioButtonFieldInput extends React.Component {
    render() {
        const { choices, name, id, onChange, value, required } = this.props;
        if (!Array.isArray(choices)) {
            console.error(
                "RadioButtonField passed 'choices' that wasn't array",
                name,
                choices
            );
            return <div></div>;
        }
        const choiceElements = choices.map(choice => {
            const choiceID = normalizeCSSID(
                ['choice', id, choice[0]].join('-')
            );
            return (
                <div
                    className={styles['radio-container']}
                    id={id}
                    key={`${id}_${choice[0]}`}
                >
                    <input
                        onChange={onChange}
                        type="radio"
                        id={choiceID}
                        name={name}
                        value={choice[0]}
                        className={styles['radio']}
                        checked={value === choice[0]}
                    />
                    <label
                        className={styles['label-lowercase']}
                        id={`for-${choiceID}`}
                        htmlFor={choiceID}
                    >
                        {choice[1]}
                    </label>
                </div>
            );
        });

        return <div>{choiceElements}</div>;
    }
}
/**
 *
 * @deprecated all new forms should use HVUI/FormikForm and HVUI/FormControl
 */
export default FieldWrapper(RadioButtonFieldInput, { reduxForm: true });
/**
 *
 * @deprecated all new forms should use HVUI/FormikForm and HVUI/FormControl
 */
export const RadioButtonField = FieldWrapper(RadioButtonFieldInput);
